<template>
  <div id="app">
    <div id="loading" v-if="loading">
      <square-grid></square-grid>
    </div>
    <div class="wrapper">
      <header>
        <app-header></app-header>
      </header>
      <main>
        <router-view></router-view>
      </main>
      <footer>
        <!-- <div class="copyright" >Powered by <a class="footer-link" href="https://luxtag.io" target="_blank">LuxTag</a></div> -->
        <img class="logo" v-on:click="link()" src="../src/assets/img/logo-powerby-luxtag.png"/>
        <!-- <div class="version" >Version: 2.0.0</div> -->
      </footer>
    </div>
  </div>


</template>

<script>
import Header from './components/Header';
import EventBus from './Buss/EventBus';
import SquareGrid from './components/SquareGrid';
// TODO: put the rout back to the root
// check if the user is loged in
export default {
  name: 'app',
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    link() {
      window.open('https://luxtag.io');
    },
  },
  computed: {
    login() {
      return this.$store.getters.getAuth.login;
    },
    accounts() {
      return this.$store.getters.getAccounts;
    },
  },
  created() {
    const that = this;

    EventBus.$on('loading-start', () => {
      that.loading = true;
    });

    EventBus.$on('loading-stop', () => {
      that.loading = false;
    });
  },
  components: {
    'app-header': Header,
    SquareGrid,
  },
};
</script>

<style>
::selection{
  background: #30AFCA;
}
html, body {
  margin: 0;
  font-family: HelveticaNeue;
  line-height: 1.5;
  font-size: 14px;
  height: 100%;
}


h1,h2,h3,h4 {
  font-family: HelveticaNeue;
}

ol, ul {
	list-style: none;
}

#loading{
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  position: absolute;
  background: rgba(219, 230, 239, 1);
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

#loading .spinner-inner{
 transform: scale(0.36) !important;
}

.persona {
  display: flex;
  align-items: center;
}

.tag{
  padding: 1em 0 0 0.2em;
  font-size: 1.4em;
  font-weight: 500;
}
main {
  grid-area: main;
  text-align: center;
  /* height: auto; */
  display: flex;
  overflow: auto;
  justify-content: center;
  font-family: HelveticaNeue;
  min-height: 535px; 
}
.el-dialog--small {
  width: 25%;
}

.el-dialog__body {
  display: flex;
  justify-content: center;
}

.rout-link > span{
  margin-left: 7px;
  margin-bottom: 3px;
}

.el-dropdown-menu__item > a {
  font-size: 12px;
  text-decoration: none;
  color: inherit;
}

.rout-link {
  display: flex;
  align-items: center;
}

.copyright{
  font-size: 11px;
  color: white;
  padding: 20px;
}
.version{
  font-size: 10px;
  color: #fff;
  padding: 20px;
}

.version b {
  color: #000;
}

header {
  grid-area: header;
  border-bottom: 1px solid #dddfe2;
  background-color:transparent;
  z-index: 1;
}

footer{
  grid-area: footer;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  color: #000;
  background-color: transparent;
}

.logo {
  display: flex;
  height: 50px;
  object-fit: contain;
  align-self: center;
  cursor: pointer;
  margin-left: 8%;
}

@media screen and (max-width: 425px) {
  footer {
    justify-content: center !important;
  }
  .logo {
    margin-left: 0% !important;
  }
}

.footer-link{
  color:#a5c4ff;
}
.footer-link:hover{
  color: #41A3F7;
}
.wrapper {
  /* background: url('./assets/img/mobile-phone-screen-disply.png') no-repeat; */
  background-color : #1A82D2;
  background-size:  860px 1059px ; 
  background-position: 560px -74px;
  display: grid;
  grid-template-areas:
    "header"
    "main"
    "footer"
}

/* message and dialog box css responsive*/
.el-message-box, .el-dialog {
  width: 98% !important;
  /* width: -moz-available;          /* WebKit-based browsers will ignore this. */
  max-width: 420px;
}
</style>



// WEBPACK FOOTER //
// App.vue?45227feb